import { render, staticRenderFns } from "./buscador-persona-moral.vue?vue&type=template&id=25702e66&scoped=true&"
import script from "./buscador-persona-moral.component.ts?vue&type=script&lang=ts&"
export * from "./buscador-persona-moral.component.ts?vue&type=script&lang=ts&"
import style0 from "./buscador-persona-moral.vue?vue&type=style&index=0&id=25702e66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25702e66",
  null
  
)

export default component.exports